import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

interface PageTransitionProps {
  children: ReactNode
}

/**
 * Wrap page-level components. Paired with <AnimatePresence mode="wait">
 * in App.tsx, this plays a 220 ms cross-fade between routes — old page
 * fades + slides up a few pixels, new page fades in from a few pixels
 * below. Feels premium, matches Linear's cadence, zero white flash
 * because nothing is ever transparent against the browser background.
 */
export default function PageTransition({ children }: PageTransitionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{
        duration: 0.22,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ease: [0.22, 1, 0.36, 1] as any,
      }}
      className="w-full h-full"
    >
      {children}
    </motion.div>
  )
}
